import BaseService from "./BaseService";
import {ROOT, ACCOUNT} from "./_base";

class CryptoRegistrationService extends BaseService {

    async cryptoRegisterInit() {
        const response = await this.getByUri(`${ROOT}/${ACCOUNT}/crypto-register-init`);
        return response.data;
    }

    async getMyNumberStatusAndCorpType() {
        const response = await this.getByUri(`${ROOT}/${ACCOUNT}/get-my-number-status`);
        return response.data;
    }

    async saveCryptoRegister(params) {
        const response = await this.post(`${ROOT}/${ACCOUNT}/save-crypt-register`, params);
        return response.data;
    }

    async confirmCryptRegister(params) {
        const response = await this.post(`${ROOT}/${ACCOUNT}/confirm-crypt-register`, params);
        return response.data;
    }

    async uploadFile(params) {
        const response = await this.post(`${ROOT}/${ACCOUNT}/upload_file`, params);
        return response.data;
    }


}
export default CryptoRegistrationService;
